/**
 * Модальный Radix-диалог считает клик по тосту sonner кликом «наружу» и закрывается.
 * Тосты живут вне диалога (контейнер `[data-sonner-toaster]`), поэтому обработчикам
 * `onPointerDownOutside` / `onFocusOutside` / `onInteractOutside` их надо отсекать.
 */
export const isInsideToaster = (event: Event): boolean =>
  event.target instanceof Element && event.target.closest('[data-sonner-toaster]') !== null

/** Обёртка над пользовательским обработчиком: он вызывается как раньше, затем — отсев тостов. */
export const ignoreToaster =
  <E extends Event>(handler?: (event: E) => void) =>
  (event: E): void => {
    handler?.(event)
    if (isInsideToaster(event)) event.preventDefault()
  }
